import React from 'react';

function BottomNav({ activeTab = 'home', onTabChange }) {
  const navItems = [
    { id: 'home', icon: 'bi-house-door-fill', label: 'Home' },
    { id: 'starting', icon: null, label: 'Starting', isLogo: true },
    { id: 'records', icon: 'bi-file-earmark-text', label: 'Records', iconClass: 'text-success' },
  ];

  const handleClick = (itemId) => {
    if (onTabChange) {
      onTabChange(itemId);
    }
  };

  return (
    <div className="bottom-nav">
      <div className="container-fluid">
        <div className="row text-center">
          {navItems.map((item) => (
            <div key={item.id} className="col-4">
              <div 
                className={`nav-item ${activeTab === item.id ? 'active' : ''} ${item.isLogo ? 'nav-logo-button' : ''}`}
                onClick={() => handleClick(item.id)}
              >
                {item.isLogo ? (
                  <div className="nav-logo-button-wrapper">
                    <img src="/logos/logo.png" alt="Logo" className="nav-logo-small" />
                  </div>
                ) : (
                  <i className={`bi ${item.icon} fs-4 ${item.iconClass || ''}`}></i>
                )}
                <div className="nav-label">{item.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BottomNav;

